import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GooglemapsComponent } from './googlemaps.component';
import { IonicModule } from '@ionic/angular';
import { GooglemapsviewPublicationComponent } from '../googlemapsview-publication/googlemapsview-publication.component';

@NgModule({
    declarations: [
        GooglemapsComponent,
        GooglemapsviewPublicationComponent
    ],
    imports: [
        CommonModule,
        IonicModule
    ],
    exports: [
        GooglemapsComponent,
        GooglemapsviewPublicationComponent
    ]
})
export class GooglemapsModule { }